<template>
  <div>
    <v-dialog/>
    <div class="box online_bg">
      <div class="wrap w1200  onsite_b">
        <!--右侧-->
        <div class="wenjuan_list">
          <dl v-for="(item, idx) in examPaperInfo" v-bind:key="item.id">
            <dt v-if="item.questionType !== 'write'">
              <span>{{(idx + 1) + '.'}}</span>{{item.questionInfoList.description}}<i>（{{getQType(item.questionType)}}）</i>
            </dt>
            <dt v-if="item.questionType == 'write'">
              <span>{{(idx+1) + '.'}}</span>
              <a :id="'write_description_' + item.questionInfoList.id" class="write_description"></a>
              <i>（{{getQType(item.questionType)}}）</i>
            </dt>
            <dd v-if="item.questionType == 'selection'">
              <p class="font14 colorBlack displayFlex" style="margin-bottom: 5px;" v-for="i in item.answerInfoList" :key="i.id">
                <input type="radio" :name="item.questionInfoList.description" :value="i.no" v-model="item.userSelections"/>
                <span class="marginSpan">{{String.fromCharCode(65 + parseInt(i.no))}}.</span> {{i.description}}
              </p>
            </dd>
            <dd v-if="item.questionType == 'multiSelection'">
              <p class="font14 colorBlack displayFlex" style="margin-bottom: 5px;" v-for="i in item.answerInfoList" :key="i.id">
                <input type="checkbox" style="opacity: 1" :name="item.questionInfoList.description" :value="i.no" v-model="i.checked" @change="getChecked(i.checked, item.userSelections, i.no)"/>
                <span class="marginSpan">{{String.fromCharCode(65 + parseInt(i.no))}}.</span> {{i.description}}</p>
            </dd>
            <dd v-if="item.questionType == 'judgement'">
              <p class="font14 colorBlack displayFlex" style="margin-bottom: 5px;" v-for="i in item.answerInfoList" :key="i.id">
                <input type="radio" :name="item.questionInfoList.description" :value="i.no" v-model="item.userSelections" style="opacity: 1;"/>
                <span class="marginSpan">{{String.fromCharCode(65 + parseInt(i.no))}}.</span> {{i.description}}
              </p>
            </dd>
            <dd v-if="item.questionType == 'short'">
              <textarea class="text_con" placeholder="请输入您的回答" v-model="item.userSelections"></textarea>
            </dd>
          </dl>
          <dl>
            <p class="wenjuan_btn"><input name="" type="button" value="提交问卷" @click="submitExam(examId)"/></p>
          </dl>
        </div>
        <!--/右侧-->
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import rangePermission from '@/utils/rangePermission'
  import config from '@/config'
  import utils from '@/utils'
  import { getCookie } from '@/store/cookies.js'
export default {
  components: { },
  data () {
    return {
      paperId: this.$route.params.paperId,
      examId: this.$route.params.id,
      examPaperInfo: [],
      answerParams: {
        examId: this.$route.params.id,
        paperId: this.$route.params.paperId,
        answerList: []
      }
    }
  },
  created () {
    this.getExamPaper(this.paperId, this.examId)
    /*rangePermission.checkScope({ // 防盗链
      itemId: this.$route.params.id,
      itemType: '02',
      permission: '02'
    }).then((r) => {
      if (!r.data) {
        let path = (process.env.NODE_ENV == 'development') ? 'http://localhost:8081' : config.domains[0] + ':' + config.webport
        window.location.href = path
      }
    })*/
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    getChecked (checked, arr, val) { // 点击单组checkbox赋值
      if (checked == true) {
        let i = arr.indexOf(val)
        if (i == -1) {
          arr.push(val)
        }
      } else {
        let i = arr.indexOf(val)
        if (i>-1) {
          arr.splice(i, 1)
        }
      }
    },
    createHTML (str, dom) {
      var replaceStr = '(<input type="text" class="tktext" value=""/>)'
      dom.html(this.$utils.bracketReplace(str, replaceStr));
    },
    createWrites (writes) {
      var that = this
      for (let i = 0; i < writes.length; i++) {
        let str = writes[i].questionInfoList.description
        let qId = writes[i].questionInfoList.id
        that.$nextTick(() => {
          $('.write_description').each(function () {
            let domId = $(this).attr('id').replace('write_description_', '')
            if (domId == qId) {
              that.createHTML(str, $(this))
            }
          })
        })
      }
    },
    inputValueDeal (id) {
      var $shadowHTML = $(id).clone() // 操作克隆的dom, 不影响原来的dom
      $shadowHTML.attr('id', $(id).attr('id') + '__copy').hide()
      $(id).after($shadowHTML)
      var allInputs = $shadowHTML.find('.tktext')
      var inputsValue = [];
      var result = {};
      for (let i = 0; i < allInputs.length; i++) {
        inputsValue.push($(allInputs[i]).val())
        $(allInputs[i]).after(inputsValue[i]);
      }
      for (let k = 0; k < inputsValue.length; k++) {
        if (inputsValue[k] == '') {
          result.isNull = true;
          break;
        } else {
          result.isNull = false;
        }
      }
      $shadowHTML.find('.tktext').remove();
      result.inputstr = $shadowHTML.html();
      $shadowHTML.remove();
      return result;
    },
    generateWritesAnswers (doms) { // 生成填空题答案
      return this.inputValueDeal(doms).inputstr
    },
    getExamPaper (id, examId) {
      var that = this
      this.$api.post(this.$global.examApiPath, '/examQuestion/getListByExam', {id: id, examId: examId}, r => {
          if (r.data) {
            r.data.forEach((o, i) => {
              if (o.questionType == 'multiSelection') {
                o.userSelections = []
              } else {
                o.userSelections = ''
              }
            })
            this.examPaperInfo = r.data
            /* 生成填空题 */
            let writes = this.examPaperInfo.filter(function (o) {
              return o.questionType == 'write'
            })
            if (writes.length > 0) {
              this.createWrites(writes)
            }
            /* 生成填空题 */
          }
      })
    },
    dealAnswer (o) {
      let tmp = ''
      var a
      function sortNumber (a, b) {
        return a - b;
      }
      if (o.questionType == 'write') {
        a = this.generateWritesAnswers('#write_description_' + o.questionInfoList.id)
      } else if (o.questionType == 'multiSelection') {
        a = o.userSelections.sort(sortNumber)
      } else {
        a = o.userSelections
      }
      if (Array.isArray(o.userSelections)) {
        a = utils.trimSpace(utils.arr2str(o.userSelections, ' '), true)
      }
      tmp = {
        id: o.infoId,
        questionId: o.questionInfoList.questionId,
        answer: a
      }
      return tmp
    },
    getQType (type) {
      switch (type) {
        case 'write': {
          return '填空';
        }
        case 'selection': {
          return '单选';
        }
        case 'multiSelection': {
          return '多选';
        }
        case 'judgement': {
          return '判断'
        }
        case 'short': {
          return '简答'
        }
      }
    },
    submitExam () {
      let that = this
      this.$modal.show('dialog', {
        title: '提交',
        text: '确定提交问卷？',
        buttons: [
          {
            title: '确定',
            default: true,
            handler: () => {
              var finalA = []
              var path = that.$OR.getUrl(getCookie('org').businessId)
              for (let i = 0; i < this.examPaperInfo.length; i++) {
                var o = this.examPaperInfo[i]
                let answer = that.dealAnswer(o)
                finalA.push(answer)
              }
              that.answerParams.answerList = finalA
              that.$api.post(that.$global.examApiPath, '/examExamScoreInfo/saveAllByObject', that.answerParams, r => {
                that.$modal.hide('dialog')
                that.$modal.show('提交问卷成功')
                that.$router.push({path: path + '/home'})
              })
            }
          },
          {
            title: '取消',
            handler: () => {
              that.$modal.hide('dialog')
            }
          }
        ]
      })
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/questionnaire/start.vue